'use strict';

export default function f($q, $http, $state, auth, utils) {
  'ngInject';

  return {
    verifyEmail: function (params) {
      var promise;

      if (verifyParams(params)) {
        promise = $http.get(utils.getApiUrl('authentication/email_validation'), {
          params: params
        });

        promise.then(function (response) {
          auth.setSessionData({
            accessToken: response.data.token,
            userId: response.data.userId
          });
          $state.go('settings');
        });
      } else {
        promise = $q.reject();
      }

      return promise;
    },
    login: function (params) {
      var promise;

      if (verifyParams(params)) {
        promise = $http.get(utils.getApiUrl('authentication/autologin_validation'), {
          params: params
        });

        promise
          .then(function (response) {
            auth.setSessionData({
              accessToken: response.data.token,
              userId: response.data.userId
            });

            this.handleAction(params);
          }.bind(this))
          .catch(function () {
            $state.go('intro');
          });
      } else {
        promise = $q.reject();
      }

      return promise;
    },
    handleAction: function (params) {
      var redirectTo;
      var stateParams;

      switch(params.action) {
      case 'conversation':
        redirectTo = 'conversations.list';
        break;

      case 'notificationSettings':
        redirectTo = 'notificationSettings';
        break;

      case 'declinedBooking':
        redirectTo = 'guides.list';
        break;

      case 'replyMessage':
        redirectTo = 'conversations.conversation';
        stateParams = {
          conversationId: params.conversationId
        };
        break;

      case 'profileSettings':
        redirectTo = 'settings';
        break;

      case 'new_locals':
        redirectTo = 'guides.list';
        stateParams = params;
        break;

      case 'trips':
        redirectTo = 'guides.trips';
        stateParams = params;
        break;

      case 'browseLocals':
        redirectTo = 'guides.list';
        stateParams = params;
        break;

      case 'referenceRequest':
        redirectTo = 'requestReference';
        break;

      case 'userProfile':
        redirectTo = 'guides.guide';
        stateParams = {
          guideId: params.userId
        };
        break;

      default:
        redirectTo = 'intro';
        break;
      }

      $state.go(redirectTo, stateParams);
    },
    loginWithSMSCode: function (code) {
      const url = utils.getApiUrl(`/authentication/sms_autologin/${code}`);

      return new $q((resolve, reject) => {
        $http.get(url)
          .then((response) => {
            auth.setSessionData({
              accessToken: response.data.token,
              userId: response.data.userId
            });
            $state.go('intro');
            resolve();
          })
          .catch(reject);
      });
    }
  };
}

const REQUIRED_PARAMS = ['uid', 'code', 'email'];

function verifyParams(params) {
  var isValid = true;

  REQUIRED_PARAMS.forEach(function (paramName) {
    if (!params.hasOwnProperty(paramName)) {
      isValid = false;
    }
  });

  return isValid;
}



// WEBPACK FOOTER //
// ./app/src/modules/autologin/autologin.service.js